<div class="twc-d-flex twc-mb-2">
    <twc-checkbox class="twc-ml-3 twc-mt-2">
        <input twcCheckboxInput #inputCheck [attr.checked]="value ? true: null" (change)="onChange(inputCheck.checked)">
    </twc-checkbox>

    <cw-color-picker [color]="color" [showInputs]="false" [readonly]="true">
    </cw-color-picker>

    <span class="twc-body twc-mt-2"> {{'FEATURE_PROPERTIES.' + property.label | translate}}</span>
</div>